import * as React from "react";

export default () => {
  return <div>Ange vad som ingår i hyran för objekten.</div>;
};
